var _style, _rect, _polygon, _polygon2, _polygon3, _polygon4, _defs, _mask, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 17",
    style: {
      enableBackground: "new 0 0 16 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{mask:url(#path-3-inside-1_5373_56536);fill:none;stroke:#D6DCE8;stroke-width:2;}\r\n\t.st3{fill:#D6DCE8;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    className: "st0",
    width: 8,
    height: 9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10,10.1 10.1,10 10,10.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "5.8,13.8 5.8,13.8 5.8,13.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.6,11.3 6.7,11.3 6.7,11.3 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.2,13.8 11.2,13.8 11.2,13.8 "
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -1,
    y: 0.5,
    width: 13.6,
    height: 15.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0.5,
    width: 13.6,
    height: 15.9,
    id: "path-3-inside-1_5373_56536"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,2.3c0-0.4,0.3-0.8,0.8-0.8h10.8v13.9H0.8c-0.4,0-0.8-0.3-0.8-0.8V2.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,2.3c0-0.4,0.3-0.8,0.8-0.8h10.8v13.9H0.8c-0.4,0-0.8-0.3-0.8-0.8V2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11,9.2L9.3,4.4H7.8L4.7,13H6l0.6-1.7l0-0.1h0.1h3.6h0.1l0,0.1l0.6,1.6V9.2z M10,10.2H7.1H7L7,10l1.4-4l0-0.1 h0.1h0.1h0.1l0,0.1l1.4,4l0,0.1H10z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: -0.1,
    className: "st3",
    width: 1.1,
    height: 17.2
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 3440,
    height: 1440,
    xlinkHref: "DC79F1B5.jpg",
    transform: "matrix(1 0 0 1 151 -975)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightComments);
export default __webpack_public_path__ + "static/media/highlight-comments.5db12e1dc058fde8d969218536c911e5.svg";
export { ForwardRef as ReactComponent };